import {PriceModel} from './Price.model';
import {AdditionalFee} from '@wix/auto_sdk_ecom_current-cart';
import {ModelContext} from '../../types/app.types';
import {SPECS} from '../specs';

export class AdditionalFeeModel {
  public code: string;
  public name: string;
  public price: PriceModel;

  constructor(params: AdditionalFeeModel) {
    this.code = params.code;
    this.name = params.name;
    this.price = params.price;
  }

  public static fromSDK(additionalFee: AdditionalFee, modelContext: ModelContext) {
    return new AdditionalFeeModel({
      code: additionalFee.code,
      name: modelContext.viewerContext.isExperimentEnabled(SPECS.UseAdditionalFeeTranslatedNameCart)
        ? additionalFee.translatedName ?? additionalFee.name
        : additionalFee.name,
      price: PriceModel.fromSDK(additionalFee.price, modelContext),
    });
  }
}
